export enum FollowUpStudySource {
	Live = "LIVE",
	SubmittedVersion = "SUBMITTED_VERSION",
	None = "NONE",
}
